import { lazy } from 'react';

export default {
  exact: false,
  name: 'Cashout',
  protected: true,
  path: '/cash-out',
  component: lazy(() => import('containers/GatewayCashout')),
};
